import type { FinalConnectionState } from '@xyflow/react'
import { useCallback } from 'react'

import type { useAgencyFlow } from './agency-flow.hook'

interface UseConnectHandlerParams {
  agencyFlow: ReturnType<typeof useAgencyFlow>
  screenToFlowPosition: (position: { x: number; y: number }) => { x: number; y: number }
}

export const useAgencyFlowConnectHandler = ({
  agencyFlow,
  screenToFlowPosition,
}: UseConnectHandlerParams) => {
  const handleConnectEnd = useCallback(
    (event: MouseEvent | TouchEvent, connectionState: FinalConnectionState): void => {
      if (connectionState.isValid || !connectionState.fromNode) return
      const clientX = 'changedTouches' in event ? event.changedTouches[0].clientX : event.clientX
      const clientY = 'changedTouches' in event ? event.changedTouches[0].clientY : event.clientY
      agencyFlow.addNodeWithConnection(
        screenToFlowPosition({ x: clientX, y: clientY }),
        connectionState.fromNode.id
      )
    },
    [screenToFlowPosition, agencyFlow]
  )

  return { handleConnectEnd }
}
